import { EventEmitter } from 'eventemitter3';
/**
 * Lightweight proxy that implements IStreamrWrapper by delegating
 * publish methods to the NetworkingWorker Comlink proxy and
 * acting as an EventEmitter for events forwarded from the worker.
 * Replaces the old main-thread StreamrWrapper facade.
 */
export class StreamrWrapperProxy extends EventEmitter {
    nwProxy;
    userId;
    constructor(nwProxy, userId) {
        super();
        this.nwProxy = nwProxy;
        this.userId = userId;
    }
    publishPermissionRequest(permissionRequest) {
        this.nwProxy.publishPermissionRequest(permissionRequest);
    }
    publishSetUserRole(setUserRole) {
        this.nwProxy.publishSetUserRole(setUserRole);
    }
    publishPrivateMessage(privateMessage) {
        this.nwProxy.publishPrivateMessage(privateMessage);
    }
    async publishPluginMessage(pluginMessage) {
        await this.nwProxy.publishPluginMessage(pluginMessage);
    }
    publishPurchaseClaimedMessage(purchaseClaimedMessage) {
        this.nwProxy.publishPurchaseClaimedMessage(purchaseClaimedMessage);
    }
    publishPurchaseConfirmedMessage(purchaseConfirmedMessage) {
        this.nwProxy.publishPurchaseConfirmedMessage(purchaseConfirmedMessage);
    }
    getMyUserId() {
        return this.userId;
    }
}
